import getSymbolFromCurrency from 'currency-symbol-map'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import PopUpIcon from '../../../commonComponents/formComponents/PopUpIcon'
import { roundToTwo } from '../../../util'
import { saveLineItemFeild, updateLineItemFeild } from '../../actions'

function MerchForm3(props) {
  const {
    isFormDisabled,
    invoiceId,
    merchandiseId,
    unitValue,
    unitCount,
    unitPrice,
    unitType,
    translate,
    shipmentCurrency
  } = props
  const dispatch = useDispatch()
  const calcValue = (unitPrice, unitCount) => {
    if(unitPrice ===0||unitCount ===0) return
    if(unitPrice && unitCount){
      return (unitPrice * unitCount)
    }
  }
  return (
    <Grid.Row>
      <Grid.Column width='4' className='divFormFeild  b-rw-0 '>
        <InputField
          id={`unitType-${invoiceId}-${merchandiseId}`}
          label={translate('UNIT_TYPE', { ns: ['default', 'lineItem'] })}
          disabled={isFormDisabled}
          boxNumber='31'
          className='field-bg dropdown100'
          labelClass='text-none'
          mandatory={false}
          direction={'right'}
          descriptionRequired={false}
          isLabel={false}
          clearable
          value={unitType}
          // text={unitType}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { unitType: value }))
            dispatch(saveLineItemFeild(merchandiseId, 'unitType', invoiceId))
          }}
        />
      </Grid.Column>
      <Grid.Column width='4' className='divFormFeild   b-rw-0 '>
        <InputField
          // subLabelText='£'
          subLabelClass='left-icon'
          isLabel={false}
          labelIcon={
            (!shipmentCurrency || shipmentCurrency === ' ') && (
              <PopUpIcon
                style={{ margin: '.1em' }}
                icon='info circle'
                popupText={translate('Currency must be selected to enable this field.', {
                  ns: ['default', 'lineItem'],
                })}
              />
            )
          }
          id={`unitCount-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate('UNIT_COUNT', { ns: ['default', 'lineItem'] })}
          mandatory={false}
          value={unitCount}
          style={{ paddingLeft: '5px' }}
          className={'field-bg'}
          clearInput={false}
          disabled={isFormDisabled || !shipmentCurrency || shipmentCurrency === ' '}
          onChange={(value) => {
            let val = calcValue(value, unitPrice) || 0
            dispatch(
              updateLineItemFeild(invoiceId, merchandiseId, {
                unitCount: value,
                unitValue: `${roundToTwo(val)}`,
              })
            )
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, ['unitCount', 'unitValue'], invoiceId))
          }}
        />
      </Grid.Column>

      <Grid.Column width='4' className='divFormFeild b-rw-0'>
        {' '}
        <InputField
          isLabel={false}
          id={`unitPrice-${invoiceId}-${merchandiseId}`}
          type='number'
          labelIcon={
            (!shipmentCurrency || shipmentCurrency === ' ') && (
              <PopUpIcon
                style={{ margin: '.1em' }}
                icon='info circle'
                popupText={translate('Currency must be selected to enable this field.', {
                  ns: ['default', 'lineItem'],
                })}
              />
            )
          }
          label={translate('UNIT_PRICE', { ns: ['default', 'lineItem'] })}
          mandatory={false}
          string={shipmentCurrency ? getSymbolFromCurrency(shipmentCurrency) : getSymbolFromCurrency('EUR')}
          addThousandsSeperator={true}
          value={parseFloat(unitPrice)}
          className={'field-bg'}
          clearInput={false}
          disabled={isFormDisabled || !shipmentCurrency || shipmentCurrency === ' '}
          onChange={(value) => {
            let val = calcValue(unitCount, value) || 0
            dispatch(
              updateLineItemFeild(invoiceId, merchandiseId, {
                unitPrice: value,
                unitValue: `${roundToTwo(val)}`,
              })
            )
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, ['unitPrice', 'unitValue'], invoiceId))
          }}
        />
      </Grid.Column>

      <Grid.Column width='4' className='divFormFeild '>
        {' '}
        <InputField
          isLabel={false}
          id={`unitValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate('ITEM_VALUE', { ns: ['default', 'lineItem'] })}
          mandatory={false}
          boxNumber='42'
          value={parseFloat(unitValue)}
          className={'field-bg'}
          string={shipmentCurrency ? getSymbolFromCurrency(shipmentCurrency) : getSymbolFromCurrency('EUR')}
          addThousandsSeperator={true}
          clearInput={false}
          disabled={true}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { unitValue: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'unitValue', invoiceId))
          }}
        />
      </Grid.Column>
    </Grid.Row>
  )
}

export default React.memo(MerchForm3)
